function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.92,16.88l-.28-.54a9.82,9.82,0,0,0-1.48-2.44,1.17,1.17,0,0,0-1.39-.24,3.59,3.59,0,0,0-.7.59,2.29,2.29,0,0,1-1.51.5h-.49a2.33,2.33,0,0,1-1.54-.51,4.38,4.38,0,0,0-.7-.59,1.29,1.29,0,0,0-1.52.23,11.75,11.75,0,0,0-1.54,2.35v.08a1.62,1.62,0,0,1,1.6.44,14.45,14.45,0,0,1,.88,1.18h7.88a1.09,1.09,0,0,0,.89-.31A1,1,0,0,0,29.92,16.88Z",
    style: {
      fill: "#fc9a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,20.1l-.27-.55A9.62,9.62,0,0,0,20,17.12a1.17,1.17,0,0,0-1.39-.25,3.59,3.59,0,0,0-.7.59,2.39,2.39,0,0,1-1.54.5h-.49a2.5,2.5,0,0,1-1.56-.51,4.3,4.3,0,0,0-.69-.59,1.23,1.23,0,0,0-1.5.23,11,11,0,0,0-1.59,2.35l-.11.23a1.55,1.55,0,0,1,1.54.45,11.45,11.45,0,0,1,.77,1.06H21a1.07,1.07,0,0,0,.93-.32A1,1,0,0,0,21.8,20.1Z",
    style: {
      fill: "#fc9a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,24.61A1.16,1.16,0,0,1,2,24.28c-.17-.21,0-.61,0-.84l.25-.55a11.22,11.22,0,0,1,1.54-2.41,1.26,1.26,0,0,1,1.51-.25,4.38,4.38,0,0,1,.7.59,2.33,2.33,0,0,0,1.5.51H8a2.37,2.37,0,0,0,1.54-.5,4.38,4.38,0,0,1,.7-.59,1.17,1.17,0,0,1,1.39.24,10.41,10.41,0,0,1,1.45,2.45l.27.54a1.1,1.1,0,0,1,.08.85,1.11,1.11,0,0,1-.93.3Z",
    style: {
      fill: "#fc9a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09,16.32a3.45,3.45,0,0,0,3.23-3.62v-.08a3.32,3.32,0,0,0-3.23-3.41H16a3.35,3.35,0,0,0-3.18,3.49v0A3.45,3.45,0,0,0,16.09,16.32Z",
    style: {
      fill: "#fc9a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78,19.65A3.43,3.43,0,0,0,11,16.05V16a3.31,3.31,0,0,0-3.22-3.4h0A3.3,3.3,0,0,0,4.62,16h0A3.52,3.52,0,0,0,7.78,19.65Z",
    style: {
      fill: "#fc9a04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.23,13.11a3.46,3.46,0,0,0,3.29-3.62V9.44h0A3.33,3.33,0,0,0,24.31,6h-.08a3.32,3.32,0,0,0-3.18,3.44h0A3.46,3.46,0,0,0,24.23,13.11Z",
    style: {
      fill: "#fc9a04"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9307782c.svg";
export { ForwardRef as ReactComponent };